export enum TransactionIDsQueryKeys {
  GET_TRANSACTIONIDS = 'GET_TRANSACTIONIDS',
}
